// Reusable print surface for drill-in traces. Portals its children to <body>
// (hidden on screen) so they print clean: no sidebar, no slide-out drawer
// scroll-clipping, and — being a body-level node — no positioned/overflow
// ancestor to clip a multi-page table. `printRegion()` flips the body class
// the scoped `@media print` rules (design-system/globals.css) key on, then
// opens the browser print dialog. Built for the waterfall allocation drawer;
// the same hook fits the Income Overview drill-ins.

import type { ReactNode } from "react";
import { createPortal } from "react-dom";

const ACTIVE_CLASS = "printing-region";

export function PrintRegion({ children }: { children: ReactNode }) {
  return createPortal(
    <div data-print-region className="hidden">
      {children}
    </div>,
    document.body,
  );
}

/** Reveal the body-level print region (hiding the app chrome) and open the
 *  browser print dialog, restoring the screen view afterward. `window.print()`
 *  blocks until the dialog closes in every supported browser, so the class is
 *  safely removed in `finally`. */
export function printRegion(): void {
  const { body } = document;
  body.classList.add(ACTIVE_CLASS);
  try {
    window.print();
  } finally {
    body.classList.remove(ACTIVE_CLASS);
  }
}
